import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SettingsGearIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Simple sliders icon - more intuitive for "settings/options" */}
      {/* Top slider */}
      <path d="M4 6h4M12 6h8" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      <circle cx="10" cy="6" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      {/* Middle slider */}
      <path d="M4 12h8M16 12h4" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      <circle cx="14" cy="12" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      {/* Bottom slider */}
      <path d="M4 18h2M10 18h10" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      <circle cx="8" cy="18" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </BaseIcon>
  ),
);

SettingsGearIcon.displayName = 'SettingsGearIcon';
